// hosannaPageData.js
const hosannaPageData = [
  /*
    { type: 'Newsletter', description: 'Sunday Service Worship Order', date: "October 2024", links: "/pdf/WesleyChurch.pdf" },
    { type: 'Order_of_service', description: 'Hymn for Praise', date: "August 2024", links: "/pdf/WesleyChurchHymnal.pdf" },
  */
    { type: 'Liturgy', description: 'Holy Communion Liturgy', date: "Nov 2024", links: "/pdf/The_Lord's_Supper.pdf" },
  ];
  
  export default hosannaPageData;
  